import { useCallback, useState, useEffect } from "react";
import Webcam from "react-webcam";
import { Button } from "antd";

export default function RecordVideo({
  agreeAccessCamera,
  capturing,
  permissionCamera,
  textCapture = "",
  webcamRef,
  onGetPermissionCamera,
  onStopCaptureClick,
  onStartCaptureClick,
}) {
  const baseTime = 15;
  const [state, setState] = useState({
    timer: baseTime,
    timerShow: "00:15",
  });

  const videoConstraints = {
    facingMode: "user",
    width: 720,
    // height: 320,
  };

  const setTime = useCallback((currentTime) => {
    if (currentTime !== 0) {
      const sec = currentTime - 1;
      const mints = Math.floor(sec / 60);
      const setSeconds = sec - mints * 60;
      const seconds =
        setSeconds < 10 || setSeconds === 0 ? "0" + setSeconds : setSeconds;

      const timerCounter =
        currentTime === 0 || currentTime === -1 ? 0 : currentTime - 1;

      setState((res) => ({
        ...res,
        timer: timerCounter,
        timerShow: "0" + mints + ":" + seconds,
      }));
    }
  }, []);

  useEffect(() => {
    if (capturing && state.timer > 0) {
      const timeOutId = setInterval(() => {
        setTime(state.timer);
      }, 1000);
      return () => clearInterval(timeOutId);
    }
    if (capturing && state.timer === 0)
      onStopCaptureClick(baseTime - state.timer);
  }, [state.timer, capturing]);

  return (
    <>
      <div className="px-5">
        <div
          className={`relative flex  justify-center items-center rounded-lg w-full max-h-[300px] overflow-hidden bg-cover bg-center ${
            !permissionCamera ? "bg-gray--8" : ""
          }`}
        >
          {!permissionCamera && (
            <div className="absolute translate-x-[-50%] translate-y-[-50%] left-[50%] top-[50%] z-1 ">
              <img
                className="w-[120px] h-[120px]"
                src={"https://cdn.firouzeh.com/public/face.svg"}
                alt="face"
              />
            </div>
          )}

          {agreeAccessCamera && (
            <Webcam
              audio={true}
              className="w-full"
              muted={true}
              ref={webcamRef}
              screenshotFormat="image/jpeg"
              videoConstraints={videoConstraints}
              onUserMedia={() => onGetPermissionCamera()}
              onUserMediaError={(err) => {
                console.log("error");
              }}
            />
          )}

          {capturing && (
            <div className="absolute left-3 bottom-3 text-white caption-12px-regular">
              {state.timerShow}
            </div>
          )}
        </div>

        <div className="p-5 mt-2 bg-white h-18px-medium shadow-sm w-full rounded-lg text-center mb-5">
          {textCapture}
        </div>

        <div className="flex justify-center items-center flex-col">
          <p className="caption-12px-medium mb-3 text-gray-0">
            {!capturing && "برای شروع ضبط ویدیو دکمه زیر را بزنید"}
          </p>
          <Button
            className={`border-[20px] rounded-[100px] h-16 w-16 p-0 duration-400 ${
              capturing
                ? "border-gray-200 hover:!border-gray-200"
                : "border-red-700 hover:!border-red-700"
            }`}
            onClick={
              capturing
                ? () => onStopCaptureClick(baseTime - state.timer)
                : onStartCaptureClick
            }
          >
            <div
              className={`transition-all duration-400 relative rounded-[4px] h-[24px] w-[24px] ${
                capturing ? " bg-red-700" : ""
              }`}
            >
              {" "}
            </div>
          </Button>
        </div>
      </div>
    </>
  );
}
